/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meetings_Colleague_One_On_OnesInputs */



/**
* | output |
* | --- |
* | "Your one-to-ones with this person" |
*
* @param {Meetings_Colleague_One_On_OnesInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meetings_colleague_one_on_ones = /** @type {((inputs?: Meetings_Colleague_One_On_OnesInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meetings_Colleague_One_On_OnesInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je one-to-ones met deze persoon")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vos one-to-ones avec cette personne")
	return /** @type {LocalizedString} */ ("Your one-to-ones with this person")
});